
  var         saveSingleFormElementData = function($form, name, value) {
                var data = name + '=' + value,
                    actionUrl = $form.prop('action'),
                    form_id = '#' + $form.prop('id');

                data += '&is_submit=true';
                if (window.yii !== undefined) {
                  data += '&' + yii.getCsrfParam() + '=' + yii.getCsrfToken();
                }

                $.ajax({
                  url: actionUrl,
                  type: 'post',
                  dataType: 'json',
                  data: data,
                  success: function (data) {
                    // TODO - for errors - update msgs, or redirect, or modal redirect
                    // all through events (1 - form change (form and data), 2 - success saved (form and data)




                    var obj = {};
                    obj.func = data.callback;
                    eval('(' + obj.func + ')()');
                  },
                  error: function () {
                    // console.error('Form save error. Check XHR.');
                  },
                  complete: function () {
                    // if (!submit_button.hasClass('loading-accept')) {
                    //     submit_button.html(submit_text);
                    // } else {
                    //     submit_button.removeClass('loading');
                    // }
                    // submit_button.prop('disabled', false);
                  }
                });
              }
  ;

  const form = {
    saveSingleFormElementData: saveSingleFormElementData
  };

  export {form};

